import { render } from "./PotentialTable.vue?vue&type=template&id=789939ce&scoped=true&lang=pug"
import script from "./PotentialTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialTable.vue?vue&type=script&setup=true&lang=js"

import "./PotentialTable.vue?vue&type=style&index=0&id=789939ce&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789939ce"]])

export default __exports__